// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2qYxo","item":"PaymentsMobile_item__bz25R","label":"PaymentsMobile_label__GqXUS","amount":"PaymentsMobile_amount__2xAVc"};